import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface CreateNewRovoConvoCommandProperties extends CommandProperties {
  /**
   * Prompt for the new conversation
   */
  prompt: string;
  /**
   * Current content ID
   */
  contentId: string;
}

/**
 * Command to invoke a new rovo conversation in AFM
 */
export const CreateNewRovoConvoCommand =
  createCommand<CreateNewRovoConvoCommandProperties>('create-new-rovo-convo');
